import { useState, useEffect } from "react";
import axios from "axios";
import { useMsal } from "@azure/msal-react";
import baseUrl from "../utils/Constants";

import "./Analytics.css";

function Analytics() {
  // const [totalViews, setTotalViews] = useState(0);
  // const [totalUserViews, setTotalUserViews] = useState(0);
  const [data, setData] = useState([]);

  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();

  let loggedInEnterpriseId = "";
  if (activeAccount)
    loggedInEnterpriseId = activeAccount.idTokenClaims.enterpriseID;

  const lkmPagesAnalytics = () => {
    axios
      .post(
        `${baseUrl}/analytics`,
        {
          enterprise_id: loggedInEnterpriseId,
        },
        {
          headers: {
            Authorization: localStorage.getItem("token"),
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        getAnalytics();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getAnalytics = () => {
    axios
      .get(`${baseUrl}/analytics`, {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setData(response.data);
        // setTotalViews(response.data.totalViews);
        // setTotalUserViews(response.data.totalUniqueUsers);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const dataArray = Array.isArray(data) ? data : [];

  const totalUserViews = dataArray.reduce(
    (acc, view) => acc + (Number(view.totalUniqueUsers) || 0),
    0
  );

  const totalViews = dataArray.reduce((acc, view) => {
    const viewData = Array.isArray(view.Data) ? view.Data : [];
    const sumOfViews = viewData.reduce(
      (sum, userView) => sum + (Number(userView.total_views) || 0),
      0
    );
    return acc + sumOfViews;
  }, 0);
  useEffect(() => {
    lkmPagesAnalytics();
  }, []);

  return (
    <>
      <span className="analytics-span">
        <img
          src="images/Home/medium-eye.png"
          className="eye-icon"
          alt="eye"
        />
        Total Views: {totalViews} &nbsp; | &nbsp; Unique Views:{" "}
        {totalUserViews}
      </span>
    </>
  );
}

export default Analytics;
